import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Representante } from './representantes.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class RepresentanteService {

  private representantesURL: string = urlJoin(environment.apiURL, 'usuarios')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getRepresentantes(params?: string ): Observable<Representante[]> {
    return this.http.get<Representante[]>(this.representantesURL+'?'+params)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          //this.toastr.error('Profesionales: '+error.error.message)
          return throwError(() => error)
        })
      )
  }

  getRepresentante(id: string): Observable<any> {
    const getRepresentanteURL = urlJoin(this.representantesURL, id)
    return this.http.get<Representante>(getRepresentanteURL)
      .pipe(
        catchError(error => {
          //this.toastr.error('Se ha producido un error obteniendo los datos del profesional')
          return throwError(() => error)
        })
      )
  }

  updateRepresentante(id: string, representante: Representante): Observable<any> {
    const updateRepresentanteURL = urlJoin(this.representantesURL, id)
    return this.http.put<Representante>(updateRepresentanteURL, representante)
      .pipe(
        tap(() => {
          //this.toastr.success('Profesional modificado correctamente');
          const updateRepresentanteSuccessMessage: string = $localize`:@@updateRepresentanteSuccessMessage:Representante modificado correctamente`;
          this.notificationsService.showSuccessNotification(updateRepresentanteSuccessMessage)
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          //this.toastr.error('Se ha producido un error modificando el profesional')
          return throwError(() => error)
        })
      )
  }

  deleteRepresentante(id: string): Observable<any> {
    const deleteRepresentanteURL = urlJoin(this.representantesURL, id)
    return this.http.delete<Representante>(deleteRepresentanteURL)
      .pipe(
        tap(() => {
          //this.notificationsService.showSuccessNotification('Nuevo representante añadido correctamente');
        }),
        catchError(error => {
          //this.toastr.error('Se ha producido un error borrando el profesional')
          return throwError(() => error)
        })
      )
  }

  updateRepresentanteEstado(id: string, accion: 'ACTIVAR' | 'DESACTIVAR'): Observable<any> {
    const updateRepresentanteEstadoURL = urlJoin(this.representantesURL, id, 'estado');
    return this.http.put<Representante>(updateRepresentanteEstadoURL, { accion })
      .pipe(
        tap(() => { }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newRepresentante(representante: Representante): Observable<any> {
    const newRepresentanteURL = urlJoin(this.representantesURL, "registro/usuario")
    return this.http.post<Representante>(newRepresentanteURL, representante)
      .pipe(
        tap(() => {
          const newRepresentanteSuccessMessage: string = $localize`:@@newRepresentanteSuccessMessage:Representante creado correctamente`;
          this.notificationsService.showSuccessNotification(newRepresentanteSuccessMessage)
        }),
        catchError(error => {
          //this.toastr.error('Se ha producido un error añadiendo el nuevo empleado profesional: '+error.error.message)
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateAvatar(id: string, avatar: FormData): Observable<any> {
    const updateAvatarURL = urlJoin(this.representantesURL, id, "/foto");
    return this.http.put<Representante>(updateAvatarURL, avatar)
      .pipe(
        tap(() => { }),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  getAvatar(id: string): Observable<any> {
    const getAvatarURL = urlJoin(this.representantesURL, id, "/descargarFoto");
    return this.http.get(getAvatarURL, { responseType: 'blob' }) // Aquí está el cambio clave
      .pipe(
        tap(() => { }),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

}
